export class Book {

    constructor(Name: string, Author: string, ISBN: string) {
        this.Name = Name;
        this.Author = Author;
        this.ISBN = ISBN;
    }

    Name: string;
    Author: string;
    ISBN: string;
}
